import { createNavigationContainerRef } from '@react-navigation/native';

/**
 * One navigation ref shared by both navigators (native + web), so services
 * outside the component tree — FCM tap-through, emergency handling — can
 * route without holding a screen's navigation prop.
 */
export const rootNavigationRef = createNavigationContainerRef<any>();

export function navigateFromNotification(route: string, params?: object): void {
  if (rootNavigationRef.isReady()) {
    rootNavigationRef.navigate(route as any, params as any);
  }
}
